export enum ThumbnailSlice {
  First,
  Middle,
  Last,
}
